import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'

const NewTemplateWindow = ({ handleCancel, templates, setTemplate, currentUserRole }) => {
  const { t } = useTranslation(['new-template-window', 'common'])
  const [stepCounter, setStepCounter] = useState(1)
  const emptyTemplate = {
    isGuided: false,
    name: '',
    rooms: [],
  }

  const renderStep = (step) => {
    switch (step) {
      case 1:
        return (
          <div className="option-button" onClick={() => setStepCounter(2)}>
            <Icon icon="moveInOut" viewBox="0 0 23 23" className="smaller-icon" />
            <span className="title">{t('new-template-window:moveInOutInspectionTitle')}</span>
          </div>
        )
      case 2:
        return (
          <div className="option-buttons-container">
            <div
              className="option-button"
              onClick={() => {
                handleCancel()
                setTemplate({ data: { ...emptyTemplate, isTemplate: false }, mode: 'create' })
              }}
            >
              <Icon icon="newPage" viewBox="0 0 39 38" className="bigger-icon" />
              <div className="column-style">
                <span className="title">{t('new-template-window:createBlankTitle')}</span>
                <span className="desc">{t('new-template-window:createBlankDesc')}</span>
              </div>
            </div>
            <div className="option-button" onClick={() => setStepCounter(3)}>
              <Icon icon="complete" viewBox="0 0 41 40" className="bigger-icon" />
              <div className="column-style">
                <span className="title">{t('new-template-window:createUsingTemplateTitle')}</span>
                <span className="desc">{t('new-template-window:createUsingTemplateDesc')}</span>
              </div>
            </div>
            {currentUserRole === 'Administrator' && (
              <div
                className="option-button"
                onClick={() => {
                  handleCancel()
                  setTemplate({ data: { ...emptyTemplate, isTemplate: true }, mode: 'create' })
                }}
              >
                <Icon icon="blocks" viewBox="0 0 39 38" className="bigger-icon" />
                <div className="column-style">
                  <span className="title">{t('new-template-window:createNewTemplateTitle')}</span>
                  <span className="desc">{t('new-template-window:createNewTemplateDesc')}</span>
                </div>
              </div>
            )}
          </div>
        )
      case 3:
        return (
          <div className="select-template-container">
            <div className="title">{t('new-template-window:selectTemplatePrompt')}</div>
            <div className="templates-selector">
              {templates.map((temp) => {
                return (
                  <div
                    key={temp.id}
                    className="template-option"
                    onClick={() => {
                      handleCancel()
                      setTemplate({ data: { ...temp, isTemplate: false }, mode: 'create' })
                    }}
                  >
                    {temp.name}
                  </div>
                )
              })}
            </div>
            <button
              type="submit"
              className={`button button-primary is-block`}
              onClick={() => setStepCounter(2)}
            >
              {t('common:actions.back')}
            </button>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className="new-template-window">
      <div className="new-template-window__container">
        <div className="window-header">
          <div className="title">{t('new-template-window:headerTitle')}</div>
          <div className="navi-button" onClick={handleCancel}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">{renderStep(stepCounter)}</div>
      </div>
    </div>
  )
}

NewTemplateWindow.propTypes = {
  handleCancel: PropTypes.func,
  setTemplate: PropTypes.func,
  templates: PropTypes.array,
  currentUserRole: PropTypes.string,
}

export default NewTemplateWindow
